"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestCatalogApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var TestCatalogApi = /** @class */ (function (_super) {
    __extends(TestCatalogApi, _super);
    function TestCatalogApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Aggregate data required to display test catalog\'s gene page
     */
    TestCatalogApi.prototype.aggregateGenePageFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.geneCode === null || requestParameters.geneCode === undefined) {
                            throw new runtime.RequiredError('geneCode', 'Required parameter requestParameters.geneCode was null or undefined when calling aggregateGenePageFromTestCatalogController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/genes/{geneCode}".replace("{".concat("geneCode", "}"), encodeURIComponent(String(requestParameters.geneCode))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GenePageDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Aggregate data required to display test catalog\'s gene page
     */
    TestCatalogApi.prototype.aggregateGenePageFromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.aggregateGenePageFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Aggregate data required to display test catalog\'s gene page
     */
    TestCatalogApi.prototype.aggregateGenePageV2FromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.geneCode === null || requestParameters.geneCode === undefined) {
                            throw new runtime.RequiredError('geneCode', 'Required parameter requestParameters.geneCode was null or undefined when calling aggregateGenePageV2FromTestCatalogController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/product-types-of-genes/{geneCode}".replace("{".concat("geneCode", "}"), encodeURIComponent(String(requestParameters.geneCode))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.GeneV2DtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Aggregate data required to display test catalog\'s gene page
     */
    TestCatalogApi.prototype.aggregateGenePageV2FromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.aggregateGenePageV2FromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Aggregate the data required to display a list of genes
     */
    TestCatalogApi.prototype.aggregateGenesForGivenTestCodesFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.genesListRequestDto === null || requestParameters.genesListRequestDto === undefined) {
                            throw new runtime.RequiredError('genesListRequestDto', 'Required parameter requestParameters.genesListRequestDto was null or undefined when calling aggregateGenesForGivenTestCodesFromTestCatalogController.');
                        }
                        queryParameters = {};
                        if (requestParameters.fields !== undefined) {
                            queryParameters['fields'] = requestParameters.fields;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/list-of-genes",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.GenesListRequestDtoToJSON)(requestParameters.genesListRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.GenesListDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Aggregate the data required to display a list of genes
     */
    TestCatalogApi.prototype.aggregateGenesForGivenTestCodesFromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.aggregateGenesForGivenTestCodesFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Aggregate data required to display test catalog\'s main category page
     */
    TestCatalogApi.prototype.aggregateMainCategoryGenesFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.categoryCode === null || requestParameters.categoryCode === undefined) {
                            throw new runtime.RequiredError('categoryCode', 'Required parameter requestParameters.categoryCode was null or undefined when calling aggregateMainCategoryGenesFromTestCatalogController.');
                        }
                        if (requestParameters.from === null || requestParameters.from === undefined) {
                            throw new runtime.RequiredError('from', 'Required parameter requestParameters.from was null or undefined when calling aggregateMainCategoryGenesFromTestCatalogController.');
                        }
                        if (requestParameters.size === null || requestParameters.size === undefined) {
                            throw new runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined when calling aggregateMainCategoryGenesFromTestCatalogController.');
                        }
                        queryParameters = {};
                        if (requestParameters.from !== undefined) {
                            queryParameters['from'] = requestParameters.from;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        if (requestParameters.query !== undefined) {
                            queryParameters['query'] = requestParameters.query;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/main-categories/{categoryCode}/genes".replace("{".concat("categoryCode", "}"), encodeURIComponent(String(requestParameters.categoryCode))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.CategoryGenesDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Aggregate data required to display test catalog\'s main category page
     */
    TestCatalogApi.prototype.aggregateMainCategoryGenesFromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.aggregateMainCategoryGenesFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Aggregate data required to display test catalog\'s main category page
     */
    TestCatalogApi.prototype.aggregateMainCategoryPageFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.categoryCode === null || requestParameters.categoryCode === undefined) {
                            throw new runtime.RequiredError('categoryCode', 'Required parameter requestParameters.categoryCode was null or undefined when calling aggregateMainCategoryPageFromTestCatalogController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/main-categories/{categoryCode}".replace("{".concat("categoryCode", "}"), encodeURIComponent(String(requestParameters.categoryCode))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CategoryV2DtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Aggregate data required to display test catalog\'s main category page
     */
    TestCatalogApi.prototype.aggregateMainCategoryPageFromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.aggregateMainCategoryPageFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Aggregate data required to display test catalog\'s main category page
     */
    TestCatalogApi.prototype.aggregateMainCategoryPageV2FromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.categoryCode === null || requestParameters.categoryCode === undefined) {
                            throw new runtime.RequiredError('categoryCode', 'Required parameter requestParameters.categoryCode was null or undefined when calling aggregateMainCategoryPageV2FromTestCatalogController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/main-categoriesV2/{categoryCode}".replace("{".concat("categoryCode", "}"), encodeURIComponent(String(requestParameters.categoryCode))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CategoryPageDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Aggregate data required to display test catalog\'s main category page
     */
    TestCatalogApi.prototype.aggregateMainCategoryPageV2FromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.aggregateMainCategoryPageV2FromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Aggregate data required to display test catalog\'s panel card
     */
    TestCatalogApi.prototype.aggregateTestPanelCardFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.panelCode === null || requestParameters.panelCode === undefined) {
                            throw new runtime.RequiredError('panelCode', 'Required parameter requestParameters.panelCode was null or undefined when calling aggregateTestPanelCardFromTestCatalogController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/test-panel-card/{panelCode}".replace("{".concat("panelCode", "}"), encodeURIComponent(String(requestParameters.panelCode))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.TestPanelCardDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Aggregate data required to display test catalog\'s panel card
     */
    TestCatalogApi.prototype.aggregateTestPanelCardFromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.aggregateTestPanelCardFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Aggregate data required to display test catalog\'s panel detailed page
     */
    TestCatalogApi.prototype.aggregateTestPanelDetailedPageFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.panelCode === null || requestParameters.panelCode === undefined) {
                            throw new runtime.RequiredError('panelCode', 'Required parameter requestParameters.panelCode was null or undefined when calling aggregateTestPanelDetailedPageFromTestCatalogController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/test-panel-detailed-page/{panelCode}".replace("{".concat("panelCode", "}"), encodeURIComponent(String(requestParameters.panelCode))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.TestPanelDetailedPageDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Aggregate data required to display test catalog\'s panel detailed page
     */
    TestCatalogApi.prototype.aggregateTestPanelDetailedPageFromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.aggregateTestPanelDetailedPageFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Aggregate data required to display test catalog\'s panel page
     */
    TestCatalogApi.prototype.aggregateTestPanelPageFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.panelCode === null || requestParameters.panelCode === undefined) {
                            throw new runtime.RequiredError('panelCode', 'Required parameter requestParameters.panelCode was null or undefined when calling aggregateTestPanelPageFromTestCatalogController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/test-panels/{panelCode}".replace("{".concat("panelCode", "}"), encodeURIComponent(String(requestParameters.panelCode))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.TestPanelPageDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Aggregate data required to display test catalog\'s panel page
     */
    TestCatalogApi.prototype.aggregateTestPanelPageFromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.aggregateTestPanelPageFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Autocomplete commercial tests
     */
    TestCatalogApi.prototype.autocompleteCommercialTestsFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.text === null || requestParameters.text === undefined) {
                            throw new runtime.RequiredError('text', 'Required parameter requestParameters.text was null or undefined when calling autocompleteCommercialTestsFromTestCatalogController.');
                        }
                        queryParameters = {};
                        if (requestParameters.text !== undefined) {
                            queryParameters['text'] = requestParameters.text;
                        }
                        if (requestParameters.aggregationType !== undefined) {
                            queryParameters['aggregationType'] = requestParameters.aggregationType;
                        }
                        if (requestParameters.productType !== undefined) {
                            queryParameters['productType'] = requestParameters.productType;
                        }
                        if (requestParameters.rrsCode !== undefined) {
                            queryParameters['rrsCode'] = requestParameters.rrsCode;
                        }
                        if (requestParameters.tags !== undefined) {
                            queryParameters['tags'] = requestParameters.tags;
                        }
                        if (requestParameters.fields !== undefined) {
                            queryParameters['fields'] = requestParameters.fields;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/autocomplete",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.CommercialTestAutocompleteDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Autocomplete commercial tests
     */
    TestCatalogApi.prototype.autocompleteCommercialTestsFromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.autocompleteCommercialTestsFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Find a rereq sets for reflex ordering scenario
     */
    TestCatalogApi.prototype.findRereqForReflexFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.codes === null || requestParameters.codes === undefined) {
                            throw new runtime.RequiredError('codes', 'Required parameter requestParameters.codes was null or undefined when calling findRereqForReflexFromTestCatalogController.');
                        }
                        if (requestParameters.rrsCode === null || requestParameters.rrsCode === undefined) {
                            throw new runtime.RequiredError('rrsCode', 'Required parameter requestParameters.rrsCode was null or undefined when calling findRereqForReflexFromTestCatalogController.');
                        }
                        queryParameters = {};
                        if (requestParameters.codes !== undefined) {
                            queryParameters['codes'] = requestParameters.codes;
                        }
                        if (requestParameters.rrsCode !== undefined) {
                            queryParameters['rrsCode'] = requestParameters.rrsCode;
                        }
                        if (requestParameters.fields !== undefined) {
                            queryParameters['fields'] = requestParameters.fields;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/rereq-set-picker-for-reflex",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Find a rereq sets for reflex ordering scenario
     */
    TestCatalogApi.prototype.findRereqForReflexFromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.findRereqForReflexFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Find a rereq set by commercial test codes
     */
    TestCatalogApi.prototype.findRereqFromCommercialTestsFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.codes === null || requestParameters.codes === undefined) {
                            throw new runtime.RequiredError('codes', 'Required parameter requestParameters.codes was null or undefined when calling findRereqFromCommercialTestsFromTestCatalogController.');
                        }
                        queryParameters = {};
                        if (requestParameters.fields !== undefined) {
                            queryParameters['fields'] = requestParameters.fields;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/rereq-set-picker/{codes}".replace("{".concat("codes", "}"), encodeURIComponent(String(requestParameters.codes))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RereqFromCommercialTestsDTOFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Find a rereq set by commercial test codes
     */
    TestCatalogApi.prototype.findRereqFromCommercialTestsFromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.findRereqFromCommercialTestsFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get partnership by id
     */
    TestCatalogApi.prototype.getPartnershipFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getPartnershipFromTestCatalogController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/partnerships/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OrderConfigResDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get partnership by id
     */
    TestCatalogApi.prototype.getPartnershipFromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPartnershipFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get full list of partner codes
     */
    TestCatalogApi.prototype.listPartnerCodesFromTestCatalogControllerRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/partner-codes",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get full list of partner codes
     */
    TestCatalogApi.prototype.listPartnerCodesFromTestCatalogController = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listPartnerCodesFromTestCatalogControllerRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Lookup commercial tests
     */
    TestCatalogApi.prototype.lookupCommercialTestsFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.codes === null || requestParameters.codes === undefined) {
                            throw new runtime.RequiredError('codes', 'Required parameter requestParameters.codes was null or undefined when calling lookupCommercialTestsFromTestCatalogController.');
                        }
                        queryParameters = {};
                        if (requestParameters.fields !== undefined) {
                            queryParameters['fields'] = requestParameters.fields;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        if (requestParameters.filters !== undefined) {
                            queryParameters['filters'] = requestParameters.filters;
                        }
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/commercial-tests/{codes}".replace("{".concat("codes", "}"), encodeURIComponent(String(requestParameters.codes))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.CommercialTestDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Lookup commercial tests
     */
    TestCatalogApi.prototype.lookupCommercialTestsFromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.lookupCommercialTestsFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get list of custom orders (aka custom panels) by given search string and RRS
     */
    TestCatalogApi.prototype.lookupCustomPanelsCamelFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.search !== undefined) {
                            queryParameters['search'] = requestParameters.search;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.rrs !== undefined) {
                            queryParameters['rrs'] = requestParameters.rrs;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/custom-orders-camel",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.CustomPanelDTOFromJSON); })];
                }
            });
        });
    };
    /**
     * Get list of custom orders (aka custom panels) by given search string and RRS
     */
    TestCatalogApi.prototype.lookupCustomPanelsCamelFromTestCatalogController = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.lookupCustomPanelsCamelFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get list of custom orders (aka custom panels) by given search string and RRS
     */
    TestCatalogApi.prototype.lookupCustomPanelsFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.search !== undefined) {
                            queryParameters['search'] = requestParameters.search;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.rrs !== undefined) {
                            queryParameters['rrs'] = requestParameters.rrs;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/custom-orders",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.CustomPanelDTOFromJSON); })];
                }
            });
        });
    };
    /**
     * Get list of custom orders (aka custom panels) by given search string and RRS
     */
    TestCatalogApi.prototype.lookupCustomPanelsFromTestCatalogController = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.lookupCustomPanelsFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Lookup latest commercial tests
     */
    TestCatalogApi.prototype.lookupLatestCommercialTestsFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.lookupLatestCommercialTestsBodyDTO === null || requestParameters.lookupLatestCommercialTestsBodyDTO === undefined) {
                            throw new runtime.RequiredError('lookupLatestCommercialTestsBodyDTO', 'Required parameter requestParameters.lookupLatestCommercialTestsBodyDTO was null or undefined when calling lookupLatestCommercialTestsFromTestCatalogController.');
                        }
                        queryParameters = {};
                        if (requestParameters.fields !== undefined) {
                            queryParameters['fields'] = requestParameters.fields;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/commercial-tests",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.LookupLatestCommercialTestsBodyDTOToJSON)(requestParameters.lookupLatestCommercialTestsBodyDTO),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.CommercialTestDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Lookup latest commercial tests
     */
    TestCatalogApi.prototype.lookupLatestCommercialTestsFromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.lookupLatestCommercialTestsFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Validate of commercial test codes against previous codes
     */
    TestCatalogApi.prototype.validateCartPostFromTestCatalogControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.validateCartRequestBodyDTO === null || requestParameters.validateCartRequestBodyDTO === undefined) {
                            throw new runtime.RequiredError('validateCartRequestBodyDTO', 'Required parameter requestParameters.validateCartRequestBodyDTO was null or undefined when calling validateCartPostFromTestCatalogController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/test-catalog/validate-cart",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ValidateCartRequestBodyDTOToJSON)(requestParameters.validateCartRequestBodyDTO),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ValidateCartResponseDTOFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Validate of commercial test codes against previous codes
     */
    TestCatalogApi.prototype.validateCartPostFromTestCatalogController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateCartPostFromTestCatalogControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return TestCatalogApi;
}(runtime.BaseAPI));
exports.TestCatalogApi = TestCatalogApi;
